import React from "react";
import { ContentState, convertToRaw } from "draft-js";
import { convertToHTML } from 'draft-convert';
import { RichEditorFontSizeStylesMap } from "./richEditorFontSizeControl";
import { createDomObjectsFromHtml } from "../../mailTemplate/utils/dom";

export function renderRichEditorContentHTML(
    styles: { [index: string]: React.CSSProperties },
    content: ContentState
): string {
    // const rawContentState = convertToRaw(content);
    // console.log('editorState.getCurrentContent() : ', content);
    // console.log('rawContentState : ', rawContentState);

    const html = convertToHTML({
        styleToHTML: (style: string) => {
            if (style === 'BOLD') {
                return <strong />;
            } else if (style === 'STRIKETHROUGH') {
                return <del />;
            } else if (
                style.includes('COLOR_')
            ) {
                return (
                    <span
                        style={{
                            color: styles[style as keyof Omit<typeof styles, 'STRIKETHROUGH'>]?.color,
                        }}
                    />
                );
            } else if (style.includes('FONTSIZE_')) {
                return (
                    <span
                        style={{
                            fontSize: RichEditorFontSizeStylesMap[style as keyof typeof RichEditorFontSizeStylesMap]?.fontSize
                        }}
                    />
                );
            }
        },
        blockToHTML: (block) => {
            const paragraphStyle: React.CSSProperties = {};
            if (block.type === 'PARAGRAPH' || block.type === 'unstyled' || block.type === 'paragraph') {
                if (block.data && (block.data.textAlign || block.data.alignment)) {
                    paragraphStyle.textAlign = (block.data.textAlign || block.data.alignment) as 'left' | 'center' | 'right' | 'justify';
                }
                return <p style={paragraphStyle} />;
            } else if (block.type === 'atomic') {
                return undefined;
            } else if (block.type === 'align-left') {
                return <p style={{ textAlign: 'left' }} />;
            } else if (block.type === 'align-center') {
                return <p style={{ textAlign: 'center' }} />;
            } else if (block.type === 'align-right') {
                return <p style={{ textAlign: 'right' }} />;
            } else if (block.type === 'align-justify') {
                return <p style={{ textAlign: 'justify' }} />;
            } else if (block.type === 'header-one') {
                return <h1 />;
            } else if (block.type === 'header-two') {
                return <h2 />;
            } else if (block.type === 'header-three') {
                return <h3 />;
            } else if (block.type === 'header-four') {
                return <h4 />;
            } else if (block.type === 'header-five') {
                return <h5 />;
            } else if (block.type === 'header-six') {
                return <h6 />;
            } else if (block.type === 'blockquote') {
                return <blockquote />;
            } else if (block.type === 'unordered-list-item') {
                return {
                    element: <li />,
                    nest: <ul />,
                };
            } else if (block.type === 'ordered-list-item') {
                return {
                    element: <li />,
                    nest: <ol />,
                };
            }
            return <p />;
        },
        entityToHTML: (entity, originalText) => {
            if (entity.type === 'LINK') {
                return <a href={entity.data.link} target={'_blank'} rel={'noreferrer'}>{entity.data.text}</a>;
            } else if (entity.type === 'IMAGE') {
                const { src, width, alignment } = entity.data;

                const imageProps: React.ImgHTMLAttributes<HTMLImageElement> = {
                    src: src,
                    style: {
                        width: width ? width + "%" : undefined,
                        display: 'block'
                    }
                };

                let containerStyle: React.CSSProperties = {};

                if (alignment) {
                    if (alignment === 'left') {
                        containerStyle = {
                            float: 'left',
                            marginRight: '20px',
                        };
                    } else if (alignment === 'right') {
                        containerStyle = {
                            float: 'right',
                            marginLeft: '20px',
                        };
                    } else if (alignment === 'center') {
                        containerStyle = {
                            display: 'block',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        };
                    }
                }

                const imgProps = { ...imageProps, style: { ...imageProps.style, ...containerStyle } };
                return <img {...imgProps} />;
            } else if (entity.type === 'image') {
                return <img src={ entity.data.src } style={{ width: entity.data.width, height: entity.data.height }}/>;
            }
            return originalText;
        }
    })(content);

    if (html.replace(/<[^>]+>/g, '') !== '\n') {
        const { document } = createDomObjectsFromHtml(html);

        const paragraphs = document.body.getElementsByTagName('p');

        for (let i = 0; i < paragraphs.length; i++) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const element = paragraphs[i]!;
            if (element.querySelector('img, video, iframe, picture')) {
                continue;
            }
            if (element.innerText.trim() === '') {
                element.innerHTML = '&nbsp;';
            }
        }

        document.querySelectorAll('figure').forEach((figure) => {
            figure.style.margin = '0';
        });

        return document.body.innerHTML;
    }

    return "";
}